<template>
  <ViewEntityContainer :entityName="entityName" :identifier="$route.params.templateId" :getMethod="getCheckListTemplate"
    :refreshOnTimestamp="true" :notificationListeners="[srEventKey]" :notificationValidator="notificationValidator">
  </ViewEntityContainer>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import ViewEntityContainer from "@/views/pim/suppliers/ViewEntityContainer.vue";
import EntityNames from "@/helpers/Constants/EntityNames.js";

export default {
  name: "ViewCheckListContainer",
  components: {
    ViewEntityContainer,
  },
  mixins: [clientAPI],

  data() {
    return {
      entityName: EntityNames.CheckList
    };
  },

  methods: {
    notificationValidator(args, identifier) {
      return args && args.checklistId == identifier;
    },
  },

  computed: {
    srEventKey() {
      return SRConst.EventKeys.CheckListChange;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>